module.exports = __webpack_public_path__ + "static/media/logo.b82b2282.svg";